import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'
import Error_false from '../../../error/error-false'
import ModalCustom from '../../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import LabelCustom from '../../../label-custom'
import Autocomplete from '../../../custom/autocomplete'
import {
  createDepartmentsAPI,
  deleteDepartmentsAPI,
  updateDepartmentsAPI
} from '../../../../services/departments'
import UseCostCenterSelect from '../../../../hooks/use-cost-center'

const schema = yup
  .object({
    department: yup.string().required('Please, Input character of Department'),
    departmentEn: yup.string().required('Please, Input Department for English'),
    departmentTh: yup.string().required('Please, Input Department for Thai')
  })
  .required()

export default function AddAndUpdateDivision({
  show,
  onCancel,
  fnGetList,
  data,
  param
}) {
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm({ resolver: yupResolver(schema) })
  const [isSubmit, setIsSubmit] = useState(false)
  const costCenterSelect = UseCostCenterSelect()

  const onSubmit = async (d) => {
    const body = {
      costId: d.costCenter?.value ?? null,
      department: d.department,
      departmentEn: d.departmentEn,
      departmentTh: d.departmentTh,
      larkEnable: d.larkEnable ?? false
    }
    if (data) {
      sendAPI(updateDepartmentsAPI({ ...param, departmentId: data.id }, body))
    } else {
      sendAPI(createDepartmentsAPI({ ...param, ...body }))
    }
  }

  useEffect(() => {
    if (data) {
      setValue('department', data.department ?? '')
      setValue('departmentEn', data.department_en ?? '')
      setValue('departmentTh', data.department_th ?? '')
      setValue('larkEnable', data.lark_enable ?? false)
      data.cost_id &&
        setValue('costCenter', {
          label: data.cost_name,
          value: data.cost_id
        })
    }
  }, [data, setValue])

  const fnDelete = () => {
    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'error',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        let body = { departmentId: data.id, orgId: param.orgId }
        sendAPI(deleteDepartmentsAPI(body))
      }
    })
  }

  const sendAPI = async (api) => {
    setIsSubmit(true)
    const resp = await api
    setIsSubmit(false)
    if (!resp) return
    if (resp.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        onCancel()
        fnGetList()
      })
    } else {
      Error_false(resp)
    }
  }

  return (
    <ModalCustom width={500} open={show} onCancel={onCancel}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label className="text-primary">
          {data ? 'Update' : 'Add'} Department
        </label>
        <Col md={12}>
          <LabelCustom text={'Department'} />
          <Controller
            name={'department'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control maxLength={2} value={value} onChange={onChange} />
            )}
          />
          {errors.department?.message && (
            <label className="small text-danger">
              {errors.department.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Department EN'} />
          <Controller
            name={'departmentEn'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                type="text"
                // pattern="^[A-Za-z\s\-\.\(\)]+$"
                maxLength={100}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors.departmentEn?.message && (
            <label className="small text-danger">
              {errors.departmentEn.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Department TH'} />
          <Controller
            name={'departmentTh'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                // pattern="^[\u0E00-\u0E7F\s]+$"
                maxLength={200}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors.departmentTh?.message && (
            <label className="small text-danger">
              {errors.departmentTh.message}
            </label>
          )}
        </Col>
        <Col md={12}>
          <LabelCustom text={'Cost Center'} />
          <Controller
            name={'costCenter'}
            control={control}
            render={({ field: { onChange, value = null } }) => (
              <Autocomplete
                isClearable={true}
                options={costCenterSelect}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors.costCenter?.message && (
            <label className="small text-danger">
              {errors.costCenter.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <Controller
            name={'larkEnable'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Group
                className="mb-3"
                controlId="formBasicCheckbox"
                value={value}
                onChange={onChange}
              >
                <Form.Check
                  checked={value}
                  type="checkbox"
                  label="Lark Enable"
                />
              </Form.Group>
            )}
          />
        </Col>

        <Col xl={12} className="mt-5 text-center">
          <Button className="me-2 px-4" variant="light" onClick={onCancel}>
            Close
          </Button>
          {data && (
            <Button
              disabled={data.count_emp > 0}
              className="me-2 px-4"
              variant="danger"
              onClick={fnDelete}
            >
              Delete
            </Button>
          )}

          <Button className="px-4" disabled={isSubmit} type="submit">
            {!data ? (
              <>Create{isSubmit && '...'}</>
            ) : (
              <>Submit{isSubmit && '...'}</>
            )}
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
